import React from 'react';
import type { ClaimWithActions } from '../types';

interface InlineClaimStatusIconProps {
  claim: ClaimWithActions;
}

/**
 * Displays a status icon for a claim based on its search status.
 * Shows a pending emoji (⏳) when search is in progress,
 * and a checkmark emoji (✅) when search is complete with results.
 */
export const InlineClaimStatusIcon: React.FC<InlineClaimStatusIconProps> = ({
  claim,
}) => {
  if (claim.search?.status === 'pending') {
    return <span style={{ marginLeft: 4 }}>⏳</span>;
  }

  if (
    (claim.search?.status === 'completed' ||
      claim.search?.status === 'timed_out') &&
    claim.search?.suggested_works &&
    claim.search?.suggested_works.length > 0
  ) {
    return <span style={{ marginLeft: 4 }}>✅</span>;
  }

  return null;
};
